module.exports = __webpack_public_path__ + "img/iron-plate.d69c12a1.png";